'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _makeStyles = require('@mui/styles/makeStyles');

var _makeStyles2 = _interopRequireDefault(_makeStyles);

var _utils = require('../utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _makeStyles2.default)(function (theme) {
  return {
    legend: (0, _extends3.default)({}, (0, _utils.getFontFromTheme)(['chartLegend'])(theme), {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start'
    }),
    entry: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginLeft: 10
    },
    text: { marginLeft: 5 }
  };
});

var Legend = function Legend(_ref) {
  var items = _ref.items,
      itemRenderer = _ref.itemRenderer;

  if (!R.is(Function, itemRenderer) || R.isNil(items) || R.isEmpty(items)) {
    return null;
  }

  var classes = useStyles();

  var legendEntries = R.addIndex(R.map)(function (entry, index) {
    var style = R.isNil(entry.color) ? {} : { color: entry.color };
    return _react2.default.createElement(
      'div',
      { className: classes.entry, style: style, key: index },
      itemRenderer(entry),
      _react2.default.createElement(
        'div',
        { className: classes.text },
        R.prop('label', entry)
      )
    );
  })(items);

  return _react2.default.createElement(
    'div',
    { className: classes.legend },
    legendEntries
  );
};

Legend.propTypes = {
  itemRenderer: _propTypes2.default.func,
  items: _propTypes2.default.array
};

exports.default = Legend;